"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _utils = require("../../utils");
var _reactBootstrap = require("react-bootstrap");
var _lodash = require("lodash");
var _BlogTags = _interopRequireDefault(require("../../components/Blog/BlogTags"));
var _BlogCard = _interopRequireDefault(require("../../components/Blog/BlogCard"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * A BlogList component
 *
 * @param {object} props Properties used for the component
 *
 * @returns {React.ReactElement} A BlogList
 */
function BlogCardList(props) {
  var [filteredResults, setFilteredResults] = (0, _react.useState)([]);
  var [pageNum, setPageNum] = (0, _react.useState)(1);
  var [displayPrevious, setDisplayPrevious] = (0, _react.useState)(false);
  var [displayNext, setDisplayNext] = (0, _react.useState)(true);
  if (!props.renderingFields) return null;
  var href = props.params.pagePath + props.params.pageQuery;
  var itemsPerPage = 18;
  var qsPage = new URLSearchParams(props.params.pageQuery).get('page');
  if (qsPage === null) qsPage = 1;
  var results = props.fields.blogs;
  var Prev = props => {
    if (displayPrevious) {
      return /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-tertiary",
        type: "submit",
        "aria-label": "Previous",
        onClick: e => submitPrev(e)
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "prev"
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: "sr-only"
      }, "Previous Page"));
    } else return null;
  };
  var Next = props => {
    if (displayNext) {
      return /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn-tertiary",
        type: "submit",
        "aria-label": "Next",
        onClick: e => submitNext(e)
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "next"
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: "sr-only"
      }, "Next Page"));
    } else return null;
  };
  function checkPrevNext(newPageNum, pages) {
    if (newPageNum <= 1) {
      setDisplayPrevious(false);
      setDisplayNext(true);
    } else if (newPageNum >= pages) {
      setDisplayPrevious(true);
      setDisplayNext(false);
    } else {
      setDisplayPrevious(true);
      setDisplayNext(true);
    }
  }
  function updateReact(move) {
    var pages = Math.ceil(results.length / itemsPerPage);
    var newVal = move === '+' ? parseInt(pageNum) + 1 : move === '-' ? parseInt(pageNum) - 1 : parseInt(move);
    if (isNaN(newVal) || newVal < 1) newVal = 1;else if (newVal > pages) newVal = pages;
    var newhref = (0, _utils.addOrUpdateUrlParam)(href, 'page', newVal);
    history.pushState({
      path: newhref
    }, '', newhref);
    var start = (newVal - 1) * itemsPerPage;
    setFilteredResults(results.slice(start, start + itemsPerPage));
    checkPrevNext(newVal, pages);
    setPageNum(newVal);
    window.scrollTo(0, 0);
  }
  function submitNext(e) {
    e.preventDefault();
    updateReact('+');
  }
  ;
  function submitPrev(e) {
    e.preventDefault();
    updateReact('-');
  }
  ;
  function submitNumber(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      updateReact(e.target.value);
    }
  }
  ;
  var Pagination = props => {
    var pages = Math.ceil(props.total / itemsPerPage);
    if (pages <= 1) {
      return null;
    } else {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "pagination--control mm-spacing"
      }, /*#__PURE__*/_react.default.createElement("form", {
        className: "form-inline",
        "aria-live": "polite"
      }, /*#__PURE__*/_react.default.createElement(Prev, null), /*#__PURE__*/_react.default.createElement("span", {
        className: "form-text"
      }, "Page"), /*#__PURE__*/_react.default.createElement("input", {
        className: "form-control",
        size: "1",
        "aria-placeholder": "Page Input",
        "aria-label": "inputNum",
        defaultValue: pageNum,
        onKeyDown: e => submitNumber(e)
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: "form-text"
      }, "of ", pages), /*#__PURE__*/_react.default.createElement(Next, null)));
    }
  };
  var numberOfListings = results.length;
  var pages = Math.ceil(results.length / itemsPerPage);

  //fix bogus querystring
  if (parseInt(qsPage) > pages) qsPage = pages;else if (parseInt(qsPage) < 1) qsPage = 1;
  var start = (parseInt(qsPage) - 1) * itemsPerPage;
  var pagedResults = results.slice(start, start + itemsPerPage);
  (0, _react.useEffect)(() => {
    setFilteredResults(pagedResults);
    setPageNum(qsPage);
    checkPrevNext(parseInt(qsPage), pages);
  }, []);
  var TagList = (0, _lodash.map)(results, (eachItem, key) => {
    if (eachItem.topics.length > 0) {
      return (0, _lodash.map)(eachItem.topics, (tag, key) => {
        return tag;
      });
    }
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "container mm-spacing bloglist"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: "mm-spacing"
  }, (0, _lodash.map)(filteredResults, (eachItem, key) => {
    return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
      className: "align-self-stretch",
      lg: 4,
      sm: 12,
      key: key
    }, /*#__PURE__*/_react.default.createElement(_BlogCard.default, {
      item: eachItem,
      id: key,
      params: props.params
    }));
  })), /*#__PURE__*/_react.default.createElement(Pagination, {
    page: qsPage,
    total: numberOfListings
  }), /*#__PURE__*/_react.default.createElement(_BlogTags.default, {
    tags: TagList.flat()
  }));
}
var _default = exports.default = BlogCardList;